var PresetService = require('../../src/dashboard/PresetService.js').default;

function PresetListDirective(serviceMessageBus, $q) {
	var directive = {
		restrict: 'A',
		templateUrl: '/script/view/PresetList.html',
		scope: {
			onSelect: '&',
			onLoad: '&',
			startPreset: '<'
		},
		controller: function($scope) {
			var self = this;
			var isLoaded = false;
			self.selectedPreset = $scope.startPreset;
			this.msgbus = serviceMessageBus.get();
			this.fileInput = document.querySelector('#importPreset');
			if(!this.msgbus) {
				serviceMessageBus.onLoad(init);
			}
			else {
				getPresetNames();
			}

			$scope.$watch('startPreset', (newVal, oldVal)=> {
				self.selectedPreset = newVal;
			})

			$scope.$on('PresetListController:updatePresetList', getPresetNames);
			$scope.$on('PresetListController:selectLastPreset', () => {
				getPresetNames().then(function() {
						self.selectPreset(self.dataPresets[0]);
					}
				);
			});

			function init(msgbus) {
				self.msgbus = msgbus;
				getPresetNames();
			}

			function getPresetNames() {
				var deferred = $q.defer();
				PresetService.getParentPresets(self.msgbus)
				.onSuccess(presets => {
					self.dataPresets = presets;
					if(!isLoaded) {
						$scope.onLoad({
							'$presets': self.dataPresets
						});
						isLoaded = true;
						console.log('startPreset', $scope.startPreset);
					}
					$scope.$apply();
					deferred.resolve();
				})
				.onFailure(resp => {
					throw new TypeError('onFailure');
				});
				return deferred.promise;
			}

			this.selectPreset = function(preset) {

				PresetService.getPreset(self.msgbus, preset.guid)
				.onSuccess(resp => {
					$scope.onSelect({
						'$preset': resp.preset,
						'$meta': preset
					});
					self.selectedPreset = preset;
					$scope.$apply();
				});
			}

			function handleFileUpload(event) {
				var file = event.target.files[0];
				if (!file) return;
				var beforeGuides = self.dataPresets.map((preset) => preset.guid);
				PresetService.prepareImportPreset(self.msgbus, file)
				.onSuccess(() => {
					getPresetNames().then(function() {
						var afterGuides = self.dataPresets.map((preset) => preset.guid);
						var targetIdx = afterGuides.findIndex((guid) => beforeGuides.indexOf(guid) === -1);
						var target = self.dataPresets[targetIdx >= 0 ? targetIdx : self.dataPresets.length - 1];
						self.selectPreset(target);
						$scope.$emit('DashboardContainerController:onRefreshDashboard');
						self.fileInput.value = '';
					})
				})
			}

			this.fileInput.addEventListener('change', handleFileUpload.bind(this));
		},
		controllerAs: 'vm'
	}

	return directive;
}

module.exports = PresetListDirective;


// WEBPACK FOOTER //
// ./resources/WEB-INF/script/directive/PresetList.js